module.exports = __webpack_public_path__ + "static/media/alcaldia.276c328b.png";